export function pascalEnumToString(text){
    if(!text) {
        return "";
    }
    return text.replace(/([a-z])([A-Z])|([A-Z]+)(?=[A-Z][a-z])/g, '$1 $2$3').trim();
}